// PANEL DE CASO (V4) — lectura del caso elegido, con la navegación ya existente hacia Central
// (deep-link ?caso=) y la acción deliberada «Ver habitación». No introduce toma, liberación,
// verificación, escalamiento ni cierre: el Radar observa.
import { ArrowUpRight, MapPin, X, User, Wrench, CircleAlert, Bell } from "lucide-react";
import { visualPriority as acentoPersona, eventSentence } from "@/components/visualV2/presentation";
import { relojAlarma } from "@/lib/centroV3/data";

export default function CasoPanel({ caso, nowMs, onCerrar, onAbrirCentral, onVerHabitacion, onFicha }) {
  if (!caso) return null;
  const ac = acentoPersona(caso.prioridad);
  return (
    <aside data-testid="radar-inst-panel-caso" data-priority={ac.key}
      className="gv2-card flex min-h-0 flex-col gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-2">
      <p className="text-[11px] font-bold uppercase tracking-wider text-slate-400">
        Caso · {caso.pendiente ? "pendiente" : (caso.estadoLabel || "").toLowerCase()}
      </p>
        <button type="button" data-testid="radar-inst-panel-cerrar" onClick={onCerrar}
          aria-label="Cerrar panel del caso"
          className="flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-700">
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="gv2-card-head">
        <span className="gv2-card-labels">
          <span className="gv2-priority-badge">{ac.key === "alta" ? <CircleAlert aria-hidden="true" /> : <Bell aria-hidden="true" />}{ac.label}</span>
          <span className="gv2-state">{caso.pendiente ? "Sin tomar" : caso.estadoLabel}</span>
        </span>
        <span className="gv2-time-block"><span className="gv2-time-label">Hace</span><span className="gv2-timer">{relojAlarma(caso.desde, nowMs)}</span></span>
      </div>
      <h3 className="gv2-title">{eventSentence(caso.verbo)}</h3>

      <dl className="space-y-1.5 text-[13px]">
        <div className="flex gap-2">
          <dt className="gv2-info-line w-20 shrink-0 gv2-meta"><User aria-hidden="true" />Quién</dt>
          <dd data-testid="radar-inst-panel-quien" className="min-w-0 font-semibold text-slate-700">
            {caso.persona_nombre || "Residente sin identificar"}
          </dd>
        </div>
        <div className="flex gap-2">
          <dt className="gv2-info-line w-20 shrink-0 gv2-meta"><MapPin aria-hidden="true" />Dónde</dt>
          <dd data-testid="radar-inst-panel-donde" className="gv2-location min-w-0 font-semibold text-slate-700">{caso.donde}</dd>
        </div>
        <div className="flex gap-2">
          <dt className="w-20 shrink-0 text-[11px] font-bold uppercase tracking-wide text-slate-400">Estado</dt>
          <dd data-testid="radar-inst-panel-estado" className="min-w-0 font-semibold text-slate-700">
            {caso.pendiente ? "Pendiente · nadie lo ha tomado" : caso.estadoLabel}
          </dd>
        </div>
        {caso.es_tecnica && (
          <div className="flex gap-2">
            <dt className="w-20 shrink-0 text-[11px] font-bold uppercase tracking-wide text-slate-400">Tipo</dt>
            <dd className="gv2-type"><Wrench aria-hidden="true" className="h-4 w-4" />Incidencia técnica</dd>
          </div>
        )}
      </dl>

      <button type="button" data-testid="radar-inst-panel-central" onClick={() => onAbrirCentral(caso)}
        className="inline-flex min-h-11 w-full items-center justify-center gap-1.5 rounded-xl bg-[#012472] px-3 text-sm font-bold text-white transition-colors hover:bg-[#012472]/90">
        Abrir en Central <ArrowUpRight className="h-4 w-4" />
      </button>
      {caso.ubicacion?.zona_id && (
        <button type="button" data-testid="radar-inst-panel-habitacion"
          onClick={() => onVerHabitacion(caso.ubicacion.zona_id)}
          className="inline-flex min-h-11 w-full items-center justify-center gap-1.5 rounded-xl border border-slate-200 px-3 text-sm font-bold text-[#012472] transition-colors hover:border-[#01CBE3]">
          <MapPin className="h-4 w-4" /> Ver {caso.ubicacion.habitacion} en el Radar
        </button>
      )}
      {caso.persona_id && (
        <button type="button" data-testid="radar-inst-panel-ficha" onClick={() => onFicha(caso.persona_id)}
          className="inline-flex min-h-11 w-full items-center justify-center gap-1.5 rounded-xl border border-slate-200 px-3 text-sm font-bold text-slate-600 transition-colors hover:border-[#01CBE3]">
          <User className="h-4 w-4" /> Ver ficha del residente
        </button>
      )}
      <p className="text-[11px] leading-snug text-slate-400">
        El Radar observa. Tomar, verificar y cerrar ocurre en Central, con las reglas vigentes de
        propiedad del caso.
      </p>
    </aside>
  );
}
